import { type EffectCallback, useEffect } from 'react';

export const useOnce = (callback: EffectCallback) => {
  return useEffect(callback, []);
};
